import React, { Component } from 'react';
export default class ProjectTiles extends Component {
  
  constructor(props) {
    super(props)
    this.state = {
      loadMore: false
    }
    this.toggleLoadMore = this.toggleLoadMore.bind(this);
  }

  toggleLoadMore() {
    const { loadMore } = this.state;
    this.setState({ loadMore: !loadMore });
  }

  filterContents() {
    const { contents } = this.props;
    const { loadMore } = this.state;
    let filteredContents = contents;
    if (!loadMore) {
      filteredContents = contents.slice(0, 9);
    }
    return filteredContents
  }

  renderTiles() {
    const filteredContents = this.filterContents();
    const renderedContents = filteredContents.map(content =>
      <div className="projects-portfolio-content col-xs-12 col-md-4" key={`content-project-${content.real_values["id"]}`}>
        <a href={content.link}>
          <div className="tile_4_3" style={{backgroundImage: `url(${content.img})`}}>
            <div className="image-fade-bottom"/>
            <div className="overlay">
              <h2>{content.title}</h2>
              <h3>{content.real_values["data"]["location"]}</h3>
            </div>
          </div>
        </a>
      </div>
    );
    return renderedContents;
  }

  renderLoadButton() {
    const { contents } = this.props;
    const { loadMore } = this.state;
    if (contents.length > 9) {
      return (
        <div className="col-xs-12" style={{textAlign: "center", marginBottom: "30px"}}>
          <div className="default-button" style={{cursor: "pointer"}} onClick={this.toggleLoadMore}>
            {loadMore ? "Show Less" : "Load More"}
          </div>
        </div>
      );
    }
    return <></>;
  }

  render() {
    return (
      <>
        {this.renderTiles()}
        {this.renderLoadButton()}
      </>
    )
  }
}
